export function initSidebar() {
	const navItems = document.querySelectorAll('.sidebar-item.guild');
	const sidebarMenu = document.querySelector('.sidebar-menu--scrollable');
    let srcData = '';

    function SwapToGif(img) {
        srcData = img.getAttribute('src');
        if (isGifVersionSupported(srcData)) {
            img.setAttribute('src', srcData.replace('.webp', '.gif'));
        }
    }

    function SwapToPng(img) {
        srcData = img.getAttribute('src');
        if (isGifVersionSupported(srcData)) {
            img.setAttribute('src', srcData.replace('.gif', '.webp'));
        }
    }

    function isGifVersionSupported(src) {
        return src.includes('/a_');
    }
	Array.from(navItems).forEach(function(item){
        let image = item.querySelector('img');
		item.addEventListener('mouseenter', function(){
			let tooltip = item.children[0].children[1];
			if (tooltip && tooltip.classList.contains('sidebar-menu__item')) {
				tooltip.style.marginTop = `-${sidebarMenu.scrollTop * 2}px`;
			}
            if (image) {
                SwapToGif(image);
            }
		});

        if (image) {
            item.addEventListener('mouseleave', function(){
                SwapToPng(image);
            });
        }
	});
}
